import React, { Component } from 'react';
import './hybrisSiteIdentifier.css';
import HsiTitle from './hsiTitle/hsiTitle.js';
import HsiMain from './hsiMain/hsiMain.js';

class HybrisSiteIdentifier extends Component {

  state = {
    chosenScores: 2,
    page: 1
  };

  render() {

    return (
      <div className="HybrisSiteIdentifierPage">
        <HsiTitle chosenScores={this.state.chosenScores} updateScore={this.updateScore} updatePage={this.updatePage} page={this.state.page}/>
        <HsiMain chosenScores={this.state.chosenScores} page={this.state.page}/>
      </div>
    );

  };

    updateScore = score => {
      this.setState({chosenScores: parseInt(score, 10), page: 1});
    }

    updatePage = page => {
      if (typeof parseInt(page, 10) === 'number') {
        this.setState({page: parseInt(page, 10)});
      }
    }

};

export default HybrisSiteIdentifier;


// WEBPACK FOOTER //
// ./src/components/content/hybrisSiteIdentifier/hybrisSiteIdentifier.js